<template>
  <div class="user-profile-form-container">
    <p>
      Twoje dane kontaktowe
    </p>
    <form
      @submit.prevent="handleSubmit()"
      class="user-profile-form"
    >
      <div class="inputs-wrapper">
        <template v-for="(input, index) in inputs">
          <div
            class="input-wrapper"
            :key="index"
          >
            <standard-input
              :name="input.name"
              :label="input.placeholder"
              :value="input.value"
              :valid="input.validation"
              :info="input.validMsg"
              @input_change="onInput($event, index)"
              @input_focus="onFocus(index)"
              :maxlength="input.name === 'phone' ? 15 : 255"
            />
          </div>
        </template>
      </div>
      <div class="user-profile-buttons">
        <standard-button
          type="submit"
          :background-color="primaryColor"
          custom-class="save-button"
          text="Zapisz zmiany"
        />
      </div>
    </form>
    <div
      v-if="message.length"
      class="login-alert-box"
    >
      {{ message }}
    </div>
  </div>
</template>

<script>
import StandardButton from '~/StandardButton';
import StandardInput from '~/StandardInput';
import { mapGetters, mapActions } from 'vuex';
import config from '@/config';
import ajax from '@/helpers/ajax';

export default {
  components: {
    StandardButton,
    StandardInput,
  },
  data() {
    return {
      message: '',
      inputs: [
        {
          name: 'firstName',
          placeholder: 'Imię',
          value: '',
          validMsg: 'Podaj imię',
          validation: true,
        },
        {
          name: 'lastName',
          placeholder: 'Nazwisko',
          value: '',
          validMsg: 'Podaj nazwisko',
          validation: true,
        },
        {
          name: 'phone',
          placeholder: 'Numer telefonu komórkowego',
          value: '',
          validMsg: 'Podaj numer telefonu',
          validation: true,
        },
        {
          name: 'email',
          placeholder: 'Adres email',
          value: '',
          validMsg: 'Podaj adres email',
          validation: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/getUserInfo',
      primaryColor: 'brand/getPrimaryColor',
    }),
  },
  methods: {
    ...mapActions({
      setUserInfo: 'user/setUserInfo',
      toggleModal: 'modal/openModal',
      closeModal: 'modal/closeModal',
      setModalContent: 'modal/setContent',
      setCallback: 'modal/setCallback',
    }),
    onInput(event, index) {
      this.inputs[index].value = event;
    },
    onFocus(index) {
      this.inputs[index].validation = true;
    },
    setInputsValues() {
      Promise.resolve(this.setUserInfo())
        .then(() => {
          this.inputs.forEach((input) => {
            input.value = this.userInfo[input.name];
          });
        });
    },
    confirmationModal() {
      this.setModalContent({
        title: 'Mój profil',
        html: '<p>Profil został zaktualizowany.</p>',
        confirm: 'Zamknij',
      });

      this.setCallback(this.closeModal);

      this.toggleModal();
    },
    validate() {
      // eslint-disable-next-line
      const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const phoneReg = /^[0-9\s- \+]{11,15}$/;
      let formIsValid = true;

      this.inputs.forEach((input) => {
        if (input.name === 'email') {
          if (!emailReg.test(input.value)) {
            input.validation = false;
            formIsValid = false;
          }
        } else if (input.name === 'phone') {
          if (!input.value) {
            input.validation = false;
            formIsValid = false;
            input.validMsg = 'Podaj numer telefonu';
          } else if (!phoneReg.test(input.value)) {
            input.validation = false;
            formIsValid = false;
            input.validMsg = 'Podaj poprawny numer (np. +48 600 600 600)';
          }
        } else if (!input.value) {
          input.validation = false;
          formIsValid = false;
        }
      });

      return formIsValid;
    },
    handleSubmit() {
      if (this.validate()) {
        this.inputs.forEach((input) => {
          input.validation = true;
        });

        const { inputs } = this;
        const userInfoToUpdate = {
          firstName: inputs[0].value,
          lastName: inputs[1].value,
          phone: inputs[2].value,
          email: inputs[3].value,
        };

        ajax.post(config.apiEndpoints.updateUserInfo, userInfoToUpdate)
          .then((res) => {
            if (res.status === 200) {
              this.setUserInfo();
              this.confirmationModal();
            }
          });
      }
    },
  },
  mounted() {
    this.setInputsValues();
  },
};
</script>
